import React from 'react';
import { Home } from './pages/Home';
type AppProps = {
  logoVariant?: 'badge' | 'wordmark';
  showFaq?: boolean;
};
export function App({
  logoVariant = 'badge',
  showFaq = true
}: AppProps) {
  return <Home logoVariant={logoVariant} showFaq={showFaq} data-id="element-0" data-mp="3ka4az1vdgbjc" />;
}